import React, {Fragment} from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import SelectorImage from "../../form/SelectorGrid/SelectorImage";
import Dropzone from "react-dropzone";
import {postData, fileUpload, sendRequest} from "../../../utils/request";
import {Tooltip} from "react-tippy";
import classNames from "classnames";
import ContentLoader from "../../layout/ContentLoader";
import {SortableContainer, SortableElement} from 'react-sortable-hoc';
import CheckBox from "../../form/CheckBox";
import {SelectButton} from "primereact/selectbutton";
import {SplitButton} from "primereact/splitbutton";
import FolderButton from "./figure/FolderButton";
import {hexToRgb, intToRGB, hashCode} from "../../../utils/other";

let imageRoles = null;

const orderByList = [
    {label: 'Abszolút', value: 'absolute_position', order: [{field: "absolute_position", direction: "ASC"}]},
    {label: 'Csoport', value: 'position', order: [{field: "role", direction: "ASC"},{field: "position", direction: "ASC"}]}
];

const ImageTemplate = (props) => {
    const borderColor = imageRoles[props.image.role]?.optionlabel ? hexToRgb(intToRGB(hashCode(imageRoles[props.image.role]?.optionlabel ))) : null;
    const border = borderColor ? `1px solid rgb(${borderColor.r},${borderColor.g},${borderColor.b})` : "none";

    const {image, onSelectionChange, isSelected} = props;
    const Holder = {};
    if (props.isSort) {
        Holder.type = "div";
        Holder.props = {};
    } else {
        Holder.type = Tooltip;
        Holder.props = {
            size: "big",
            html: <Fragment>
                    <div>{image.path + image.name}</div>
                    <div className="label label-default">{imageRoles[image.role]?.optionlabel}</div>
                </Fragment>
        }
    }
    return (
        <Holder.type {...Holder.props}>
            <div onClick={(e) => onSelectionChange(e, image)} className={classNames("image", {active: !props.isSort && !props.disabled && isSelected(image), disabled: props.disabled, sorting: props.isSort})} style={{backgroundImage: `url('${image.url}')`, border: `${border}`}}>
                <img src={image.url} />
                <span className={"image-role"}>{imageRoles[props.image.role]?.optionlabel && imageRoles[props.image.role]?.optionlabel}</span>
                <span className="file">
                    <span className="path">{image.path}</span>
                    <span className="name">{image.name}</span>
                </span>
                <div className="action-buttons">
                    <div className="edit-btn button" onClick={(e) => props.loadForm && props.loadForm(image)}/>
                    <div className="delete-btn button" onClick={(e) => props.delete(e, image)}/>
                </div>
            </div>
        </Holder.type>
    );
}

class figureActionGallery extends React.Component {

    state = {
        disabled: false,
        id: new Date().getTime(),
        figures: [],
        isSort: false,
        loading: false,
        orderBy: orderByList[0].value,
        defaultImageRole: "_null"
    }

    componentDidMount() {
        this.getImageRoles();
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
       if (prevProps.component !== this.props.component) {
           this.getImageRoles();
       }
    }

    getImageRoles = () => {
        const optionName = 'image_role';
        this.optionRequest && this.optionRequest.abort();
        this.optionRequest = sendRequest({
            option: "componentlist",
            component: "option",
            itemsperpage: 0,
            filter: [{filters: [{field: "xtradata", value: this.props.component},{field: "xtradata", operator: "isnull"}], operator: "OR"}],
            optionname: optionName
        }).then((data) => {
            const items = {};
            data?.items?.map((option) => {
                items[option.optionid] = option
            });
            imageRoles = {_null: {optionlabel: "Csoport nélkül", optionid: null}, ...items};
            this.forceUpdate();
        });
    }

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    openDialog = () => {
        if (this.dropzoneRef) {
            this.dropzoneRef.open();
        }
    }

    onSortEnd = ({oldIndex, newIndex}) => {
        if (oldIndex !== newIndex) {
            this.setState({loading: true}, () => {
                //console.log(oldIndex, newIndex);
                /*this.setState(({items}) => ({
                    items: arrayMove(items, oldIndex, newIndex),
                }));*/
                //this.setState({disabled: false});
                const {componentConfig} = this.props;

                const oldPosition = parseInt(this.state.figures[oldIndex][this.state.orderBy]);
                const distance = Math.abs(oldIndex - newIndex);
                const newPosition = (oldIndex - newIndex) > 0 ? oldPosition - distance : oldPosition + distance;
                const role = this.state.figures[oldIndex].role || null;

                let direction = 0;
                if (oldIndex > newIndex) {
                    direction = 1;
                }
                this.orderRequest && this.orderRequest.abort && this.orderRequest.abort();
                this.orderRequest = postData({
                    action: componentConfig.componentname + ".updateSort",
                    from: oldPosition < 1 ? 1 : oldPosition,
                    to: newPosition < 1 ? 1 : newPosition,
                    field: this.state.orderBy,
                    direction,
                    role,
                    component: this.props.component,
                    component_id: this.props.componentId
                });
                this.orderRequest.then(() => {
                    this.list && this.list.refresh && this.list.refresh();
                    this.setState({loading: false});
                });
                this.orderRequest.catch((e) => {
                    this.setState({loading: false});
                });
            });
        }
    };

    onSortStart = () => {
        //this.setState({disabled: true});
    };

    onDrop = async (acceptedFiles) => {
        if (acceptedFiles.length) {
            try {
                /*const response = */
                await fileUpload({
                    files: acceptedFiles,
                    action: this.props.componentConfig.componentname + ".bulkCreate",
                    component: this.props.values.component || this.props.component,
                    component_id: this.props.values.componentId || this.props.componentId,
                    roles: Array(acceptedFiles.length).fill(imageRoles[this.state.defaultImageRole || Object.keys(imageRoles || {})[0] || 0]?.optionid || null)
                });
                this.refresh();
            } catch (e) {
                console.error(e);
            }
        }
    }

    imageDeleteAction = async (e, image) => {
        e && e.preventDefault();
        e && e.stopPropagation();
        await this.props.deleteForm(e, image);
        this.list && this.list.refresh && this.list.refresh();
    }

    render() {
        if (imageRoles === null) {
            return <ContentLoader/>;
        }
        let {view, componentConfig, filter, selection, isLoading} = this.props;
        if (this.props.component && this.props.componentId) {
            filter = filter || [];
            if (!Array.isArray(filter)) {
                filter = [filter];
            }
            filter.push({field: "component", value: this.props.component});
            filter.push({field: "component_id", value: this.props.componentId});
        }
        const props = {componentConfig, filter, loading: isLoading || this.state.loading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        const currentOrderBy = orderByList.find((option) => {
            return option.value + "" === "" + this.state.orderBy
        });
        let orderBy = currentOrderBy?.order;
        const containerProps = {
            rowTemplate: (props) => {
                return <ImageTemplate {...props} delete={this.imageDeleteAction} isSort={this.state.isSort} orderBy={this.state.orderBy} currentOrderBy={currentOrderBy}/>
            }
        };
        if (this.state.isSort) {
            const SortableImageTemplate = SortableElement((props) => <ImageTemplate {...props} delete={this.imageDeleteAction} isSort={this.state.isSort} orderBy={this.state.orderBy} currentOrderBy={currentOrderBy}/>);
            const SortableImages = SortableContainer((props) => {
                return (
                    <div {...props}>
                        {React.Children.toArray(props.children).map((Child, index) => <Child.type {...Child.props} index={index} collection={currentOrderBy.value + "" === "absolute_position" ? 0 : (Child?.props?.image?.role || 0)} />)}
                    </div>
                );
            });
            containerProps.containerTemplate = (props) => <SortableImages
                {...props}
                id={this.state.id}
                helperContainer={() => document.getElementById(this.state.id)}
                axis="xy"
                lockToContainerEdges={true}
                helperClass="dragging"
                onSortStart={this.onSortStart}
                onSortEnd={this.onSortEnd}
            />;
            containerProps.rowTemplate = SortableImageTemplate;
        }
        return (
            <Dropzone disableClick disabled={this.state.isSort} className="image-pool" ref={(node) => { this.dropzoneRef = node; }} onDrop={this.onDrop}>
                <SelectorGrid
                    type={(props) => <SelectorImage {...props} {...containerProps} />}
                    ref={(el) => this.list = el}
                    paginatorRight={(props) => <Fragment>
                            <CheckBox
                                onIcon={{lib: "fa", name: "arrows-alt"}}
                                offIcon={{lib: "fa", name: "arrows-alt"}}
                                value={this.state.isSort}
                                saveChanges={() => this.setState({isSort: !this.state.isSort})}
                                {...props}
                            />
                            <FolderButton
                                {...props}
                                component={this.props.component}
                                component_id={this.props.componentId}
                                onComplete={() => {
                                    this.list && this.list.refresh();
                                }}
                            />
                            <SelectButton
                                value={this.state.orderBy}
                                options={orderByList}
                                onChange={(e) => this.setState({orderBy: e.value || orderByList[0].value})}
                                {...props}
                            />
                            <SplitButton
                                onClick={this.openDialog}
                                label={this.state.defaultImageRole === "_null" ? "" : (imageRoles[this.state.defaultImageRole || Object.keys(imageRoles)[0]].optionlabel)}
                                icon="fa fa-upload"
                                model={Object.keys(imageRoles || {}).map((key) => {
                                    return {
                                        label: imageRoles[key].optionlabel,
                                        command: (e) => {
                                            this.setState({defaultImageRole: key});
                                        }
                                    }
                                })}
                                className="p-button-secondary"
                                {...props}
                            />
                            {/*<Button onClick={this.openDialog} icon={{lib: "fa", name: "upload"}} {...props}/>*/}
                        </Fragment>
                    }
                    gridid={this.props.gridid !== undefined ? this.props.gridid : "figureActionGallery"}
                    {...props}
                    view={[componentConfig.idfield, "id", "path", "name", "url", "position", "absolute_position", "role"]}
                    orderBy={orderBy}
                    selection={selection}
                    onLoadCompleted={(data) => {
                        this.setState({figures: data.rows});
                    }}
                    onSelectionChange={(selection) => this.props.loadForm(selection.value)}
                    pageSize={0}
                />
            </Dropzone>
        );
    }
}

export default figureActionGallery;
